<template>
  <v-dialog
    :value="enableDialog"
    persistent
    scrollable
    width="1400"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <v-card
      v-if="manifest"
    >
      <v-card-title>
        {{ dialogTitle }}（{{ manifest.manifest_type | manifest_type_to_label }}）
      </v-card-title>
      <v-card-subtitle>
        マニフェスト番号: {{ manifest.manifest_no }}
      </v-card-subtitle>
      <v-divider />
      <v-card-title>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          grow
        >
          <v-tab
            :disabled="disableTab"
            href="#manifest"
          >
            マニフェスト
            修正・取消
          </v-tab>
          <v-tab
            v-if="indication_setting.transport.enable"
            :disabled="disableTab"
            href="#transport_report"
          >
            運搬報告 修正・取消
          </v-tab>
          <v-tab
            v-if="indication_setting.disposal.enable"
            :disabled="disableTab"
            href="#disposal_report"
          >
            処分終了報告 修正・取消
          </v-tab>
          <v-tab
            v-if="indication_setting.final_disposal.enable"
            :disabled="disableTab"
            href="#final_disposal_report"
          >
            最終処分終了報告 取消
          </v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text style="max-height: 65vh;">
        <v-tabs-items v-model="tab">
          <!-- マニフェスト修正取消 -->
          <v-tab-item value="manifest">
            <validation-observer ref="manifestValidator">
              <modify-manifest-report-form
                :can-edit="editManifest"
                :manifest="manifest"
                :manifest-draft="manifestDraft"
                :manifest-draft-transport="manifestDraftTransport"
                :quantity-units="quantityUnits"
                :quantity-confirms="quantityConfirms"
                :manifest-disposal="manifestDisposal"
                :hazardous-substances="hazardousSubstances"
                :packings="packings"
                :transportations="transportations"
                :disposal-methods="disposalMethods"
                :deliverers="emissionDeliverers"
                :registers="emissionRegisters"
                :drivers="drivers"
                :vehicles="vehicles"
                :items="items"
              />
            </validation-observer>
          </v-tab-item>
          <!-- /マニフェスト修正取消 -->
          <!-- 運搬報告 修正・取消 -->
          <v-tab-item value="transport_report">
            <validation-observer ref="transportReportValidator">
              <modify-manifest-transport-report-form
                :can-edit="editTransportReport"
                :manifest="manifest"
                :manifest-draft="manifestDraft"
                :manifest-draft-transport="manifestDraftTransport"
                :current-draft-transport-id="currentDraftTransportId"
                :transport-sections="transportSections"
                :quantity-units="quantityUnits"
                :valuables-quantity-units="valuablesQuantityUnits"
                :vehicles="vehicles"
                :users="users"
                :drivers="drivers"
                @sectionChangeEvent="sectionChangeEvent"
              />
            </validation-observer>
          </v-tab-item>
          <!-- /運搬報告 修正・取消 -->
          <!-- 処分終了報告 修正・取消 -->
          <v-tab-item value="disposal_report">
            <validation-observer ref="disposalReportValidator">
              <modify-disposal-report-form
                :can-edit="editDisposalReport"
                :manifest="manifest"
                :manifest-draft="manifestDraft"
                :manifest-disposal="manifestDisposal"
                :quantity-units="quantityUnits"
                :drivers="drivers"
                :users="users"
                :vehicles="vehicles"
                @inputSectionChangeEvent="inputSectionChangeEvent"
              />
            </validation-observer>
          </v-tab-item>
          <!-- /処分終了報告 修正・取消 -->
          <v-tab-item value="final_disposal_report">
            <validation-observer ref="finalDisposalReportValidator">
              <modify-final-disposal-report-form
                :manifest-final-disposals="manifestDraftFinalDisposals"
                :manifest="manifest"
              />
            </validation-observer>
          </v-tab-item>
        </v-tabs-items>

        <manifest-transport
          :manifest-transports="manifestTransports"
          :disposal-end-middle="disposalEndMiddle"
          :final-disposal-end="finalDisposalEnd"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <!--
          ボタン押下可能判定に加え、押下不可条件として以下を追加
          ・タブが「処分終了報告 修正・取消」で、報告区分が「最終」で、紐付く1次マニが処理中
          ・タブが「最終処分終了報告 取消」で、紐付く1次マニが処理中
        -->
        <v-btn
          :disabled="
            !enableRemoveButton ||
            (((tab === 'disposal_report' && registeredDisposalReportType === 'last_report') || tab === 'final_disposal_report') && secondManifestJobWorking)
          "
          class="error"
          @click="cancelButtonClickEvent"
        >
          取消
        </v-btn>
        <!--
          以下に該当する場合はメッセージを表示
          ・タブが「処分終了報告 修正・取消」で、報告区分が「最終」で、紐付く1次マニが処理中
          ・タブが「最終処分終了報告 取消」で、紐付く1次マニが処理中
        -->
        <strong
          v-if="
            ((tab === 'disposal_report' && registeredDisposalReportType === 'last_report') || tab === 'final_disposal_report') && secondManifestJobWorking
          "
          class="ml-2 red--text text--lighten-1"
        >
          紐付く1次マニフェストの最終処分終了報告作成中の為、取消操作を行うことはできません。
        </strong>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>

        <v-btn
          v-if="!showRegisterButton"
          :disabled="!enableEditButton"
          color="primary"
          @click="editButtonClickEvent"
        >
          編集
        </v-btn>
        <v-btn
          v-if="showRegisterButton"
          color="primary"
          @click="registerButtonClickEvent"
        >
          登録
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-dialog>
</template>
<script>
import ModifyManifestReportForm from './forms/_ModifyManifestReportForm'
import ModifyManifestTransportReportForm from './forms/_ModifyManifestTransportReportForm'
import ModifyDisposalReportForm from './forms/_ModifyDisposalReportForm'
import ModifyFinalDisposalReportForm from './forms/_ModifyFinalDisposalReportForm'
import ManifestTransport from './_ManifestTransport'
import {mapActions} from 'vuex'
import Confirm from '@/components/Confirm'

export default {
  comments: '4タブ(EDI)',
  name: 'ManifestManagementEditDialog',
  components: {
    ModifyManifestReportForm,
    ModifyManifestTransportReportForm,
    ModifyDisposalReportForm,
    ModifyFinalDisposalReportForm,
    ManifestTransport,
    Confirm,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetManifestId: {
      type: Number,
      default: () => null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    quantityUnits: {
      type: Array,
      default: () => [],
    },
    valuablesQuantityUnits: {
      type: Array,
      default: () => [],
    },
    quantityConfirms: {
      type: Array,
      default: () => [],
    },
    packings: {
      type: Array,
      default: () => [],
    },
    hazardousSubstances: {
      type: Array,
      default: () => [],
    },
    transportations: {
      type: Array,
      default: () => [],
    },
    disposalMethods: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Array,
      default: () => [],
    },
    drivers: {
      type: Array,
      default: () => [],
    },
    vehicles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: 0,
      dialogTitle: 'マニフェスト詳細',
      manifest: null,
      manifestDisposal: null,
      manifestDraft: null,
      // classificationType: null,
      currentDraftTransportId: null,
      manifestDraftTransport: null,
      finalDisposalRegisterAt: null,
      manifestDraftFinalDisposals: [],
      manifestTransports: [],
      transportSections: [],
      disposalEndMiddle: {},
      finalDisposalEnd: {},
      emissionDeliverers: [],
      emissionRegisters: [],
      editManifest: false,
      editTransportReport: false,
      editDisposalReport: false,
      editFinalDisposalReport: false,
      showRegisterButton: false,
      exCanRemoveFinalDisposal: true,
      secondManifestJobWorking: false,
      registeredDisposalReportType: null,
      selectedDisposalInputSection: 'disposal',
      /**
       * 他社運搬であるかを表現するフラグ
       * true: 他社運搬, false: 自社運搬
       */
      proxyRequest: false,
      disableTab: false,
      /**
       * タブの制御
       */
      indication_setting: {
        manifest: {
          enable: false,
          editable: false,
          removable: false
        },
        transport: {
          enable: false,
          editable: false,
          removable: false
        },
        disposal: {
          enable: false,
          editable: false,
          removable: false
        },
        final_disposal: {
          enable: false,
          editable: false,
          removable: false
        }
      }
    }
  },
  computed: {
    /**
     * 取り消しボタンの制御
     * @returns {boolean}
     */
    enableRemoveButton () {
      if (this.tab === 'manifest') {
        return this.indication_setting.manifest.removable
      } else if (this.tab === 'transport_report') {
        return this.indication_setting.transport.removable
      } else if (this.tab === 'disposal_report') {
        return this.indication_setting.disposal.removable
      } else if (this.tab === 'final_disposal_report') {
        return this.indication_setting.final_disposal.removable
      }
      return false
    },
    /**
     * 編集ボタンの制御
     * @returns {boolean}
     */
    enableEditButton () {
      if (this.tab === 'manifest') {
        return this.indication_setting.manifest.editable
      } else if (this.tab === 'transport_report') {
        return this.indication_setting.transport.editable
      } else if (this.tab === 'disposal_report') {
        return this.indication_setting.disposal.editable
      } else if (this.tab === 'final_disposal_report') {
        return this.indication_setting.final_disposal.editable
      }
      return false
    },
  },
  watch: {
    enableDialog (newValue) {
      this.manifest = null
      this.manifestTransports = []
      this.emissionDeliverers = []
      this.emissionRegisters = []
      this.manifestDraftTransport = null
      this.transportSections = null
      this.disposalEndMiddle = {}
      this.finalDisposalEnd = {}
      this.dialogTitle = 'マニフェスト詳細'
      this.secondManifestJobWorking = false;
      this.registeredDisposalReportType = null;
      this.selectedDisposalInputSection = 'disposal'
      this.proxyRequest = false;
      if (newValue) {
        this.showRegisterButton = false
        this.disableTab = false
        this.tab = 'manifest'
        this.editManifest = false
        this.editTransportReport = false
        this.editDisposalReport = false
        this.editFinalDisposalReport = false
        this.setVariable()
      }
    },
    transportSections: {
      handler: function (transportSections) {
        if (transportSections && transportSections.length > 0) {
          this.currentDraftTransportId = transportSections[0].value
        }
      },
      deep: true
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestManagementsManifest', {
      fetchManifest: 'show',
      updateManagementManifest: 'update',
      cancelManagementManifest: 'destroy'
    }),
    ...mapActions('DriverManifestManagementsManifestTransport', {
      fetchManifestTransport: 'show',
      updateManagementTransport: 'update',
      cancelManagementTransport: 'destroy',
    }),
    ...mapActions('DriverManifestManagementDisposal', {
      updateManagementDisposal: 'update',
      cancelManagementDisposal: 'destroy',
    }),
    ...mapActions('DriverManifestManagementFinalDisposal', {
      cancelManagementFinalDisposal: 'delete',
    }),
    ...mapActions('DriverMasterSearchEmissionDeliverer', {
      fetchEmissionDeliverers: 'index'
    }),
    ...mapActions('DriverMasterSearchEmissionRegister', {
      fetchEmissionRegisters: 'index'
    }),
    ...mapActions('DriverManifestRestManifestTransport', {
      updateRestManagementTransport: 'update',
      cancelRestManagementTransport: 'destroy',
    }),

    /**
     * 取消しボタン クリックイベント
     */
    cancelButtonClickEvent () {
      let modalOption = { title: '取消', message: '取消しますがよろしいですか？', options: { width: 320, titleColor: 'red', isCancelButton: true } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          if (this.tab === 'manifest') {
            this.cancelManagementManifest({ id: this.targetManifestId }).then(() => {
              this.$emit('registerEvent')
            })
          } else if (this.tab === 'transport_report') {
            if (this.proxyRequest) {
              this.cancelRestManagementTransport({ manifest_id: this.targetManifestId, id: this.currentDraftTransportId }).then(() => {
                this.$emit('registerEvent')
              })
            } else {
              this.cancelManagementTransport({manifest_id: this.targetManifestId, id: this.currentDraftTransportId}).then(() => {
                this.$emit('registerEvent')
              })
            }

          } else if (this.tab === 'disposal_report') {
            this.cancelManagementDisposal({id: this.targetManifestId}).then(() => {
              this.$emit('registerEvent')
            })
          } else if (this.tab === 'final_disposal_report') {
            this.cancelManagementFinalDisposal({id: this.targetManifestId}).then(() => {
              this.$emit('registerEvent')
            })
          }
        }
      })
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      const $self = this;
      if (this.tab === 'manifest') {
        this.$refs.manifestValidator.validate().then((result) => {
          if(result) {
            setTimeout($self.registerManifest, 500);
          }
        })
      } else if (this.tab === 'transport_report') {
        this.$refs.transportReportValidator.validate().then((result) => {
          if(result) {
            setTimeout($self.registerTransport, 500);
          }
        })
      } else if (this.tab === 'disposal_report') {
        this.$refs.disposalReportValidator.validate().then((result) => {
          if(result) {
            setTimeout($self.registerDisposal, 500);
          }
        })
      }
    },
    /**
     * 編集ボタン クリックイベント
     */
    editButtonClickEvent () {
      // 保留中の場合、保留対象となっているタブのみ編集可能
      if (this.tab === 'manifest') {
        this.editManifest = true
      } else if (this.tab === 'transport_report') {
        this.editTransportReport = true
      } else if (this.tab === 'disposal_report') {
        this.editDisposalReport = true
      } else if (this.tab === 'final_disposal_report') {
        this.editFinalDisposalReport = true
      }
      this.showRegisterButton = true
      this.disableTab = true
      this.dialogTitle = 'マニフェスト編集'
    },
    /**
     * 初期設定
     */
    setVariable () {

      this.fetchManifest({ id: this.targetManifestId }).then((content) => {
        this.manifest = content.manifest
        // this.classificationType = content.classification_type
        this.manifestDraft = content.manifest_draft
        this.manifestDisposal = content.disposal
        this.transportSections = content.transport_sections
        if (this.transportSections && this.transportSections.length > 0) {
          this.currentDraftTransportId = this.transportSections[0]['value']
          this.setManifestTransport(this.currentDraftTransportId)
        }
        // １次マニで排出事業者ありの場合は排出事業者に紐付く引渡担当者、登録担当者を展開する.
        if (this.manifest.level === 'first_manifest' && this.manifest.supplierable_id) {

          const emissionLocationId = this.manifest.use_spot_emission_location ? null : this.manifest.supplierable_location_id

          this.fetchEmissionDeliverers({
            id: this.manifest.supplierable_id,
            emission_location_id: emissionLocationId
          }).then((content) => {
            this.emissionDeliverers = content.deliverers
          })
          this.fetchEmissionRegisters({
            id: this.manifest.supplierable_id,
            emission_location_id: emissionLocationId
          }).then((content) => {
            this.emissionRegisters = content.registers
          })
        }
        this.manifestDraftFinalDisposals = content.final_disposals
        this.manifestTransports = content.manifest_transports
        this.disposalEndMiddle = content.disposal_end_middle
        this.finalDisposalEnd = content.final_disposal_end
        this.indication_setting = content.indication_setting
        this.secondManifestJobWorking = content.second_manifest_job_working
        this.registeredDisposalReportType = content.registered_disposal_report_type
      })
    },
    /**
     * マニフェスト修正登録
     */
    registerManifest () {
      const params = {
        collected_date: this.manifestDraft.collected_date,
        deliver_staff: this.manifestDraft.deliver_staff,
        register_staff: this.manifestDraft.register_staff,
        contact_number_1: this.manifestDraft.contact_number_1,
        contact_number_2: this.manifestDraft.contact_number_2,
        contact_number_3: this.manifestDraft.contact_number_3,
        item_id: this.manifestDraft.item_id,
        item_type: this.manifestDraft.item_type,
        waste_name: this.manifestDraft.waste_name,
        quantity: this.manifestDraft.quantity,
        quantity_unit_id: this.manifestDraft.quantity_unit_id,
        quantity_confirm_id: this.manifestDraft.quantity_confirm_id,
        packing_id: this.manifestDraft.packing_id,
        packing_quantity: this.manifestDraft.packing_quantity,
        hazardous_substance_1_id: this.manifestDraft.hazardous_substance_1_id,
        hazardous_substance_2_id: this.manifestDraft.hazardous_substance_2_id,
        hazardous_substance_3_id: this.manifestDraft.hazardous_substance_3_id,
        hazardous_substance_4_id: this.manifestDraft.hazardous_substance_4_id,
        hazardous_substance_5_id: this.manifestDraft.hazardous_substance_5_id,
        hazardous_substance_6_id: this.manifestDraft.hazardous_substance_6_id,
        transportation_id: this.manifestDraft.transportation_id,
        disposal_method_id: this.manifestDraft.disposal_method_id,
        note_1: this.manifestDraft.note_1,
        note_2: this.manifestDraft.note_2,
        note_3: this.manifestDraft.note_3,
        note_4: this.manifestDraft.note_4,
        note_5: this.manifestDraft.note_5,
        transport_user_name: this.manifestDraft.transport_user_name,
        vehicle_number: this.manifestDraft.vehicle_number,
      }
      this.updateManagementManifest({id: this.targetManifestId, params: params}).then(() => {
        this.$emit('registerEvent')
      })
    },
    /**
     * 運搬報告修正登録
     */
    registerTransport () {
      const params = {
        report_reporter_name: this.manifestDraftTransport.report_reporter_name,
        report_transport_user_name: this.manifestDraftTransport.report_transport_user_name,
        report_transport_quantity: this.manifestDraftTransport.report_transport_quantity,
        report_transport_quantity_unit_id: this.manifestDraftTransport.report_transport_quantity_unit_id,
        report_valuables_collecting_quantity: this.manifestDraftTransport.report_valuables_collecting_quantity,
        report_valuables_collecting_quantity_unit_id: this.manifestDraftTransport.report_valuables_collecting_quantity_unit_id,
        report_vehicle_number: this.manifestDraftTransport.report_vehicle_number,
        report_transport_completed_date: this.manifestDraftTransport.report_transport_completed_date,
        report_note: this.manifestDraftTransport.report_note,
      }

      /**
       * 他社運搬区間の運搬終了報告であれば
       */
      if (this.proxyRequest) {
        this.updateRestManagementTransport({ manifest_id: this.targetManifestId, id: this.currentDraftTransportId , params: params }).then(() => {
          this.$emit('registerEvent')
        })
      } else {
        this.updateManagementTransport({ manifest_id: this.targetManifestId, id: this.currentDraftTransportId , params: params }).then(() => {
          this.$emit('registerEvent')
        })
      }
    },
    /**
     * 処分報告修正登録
     */
    registerDisposal () {
      
      // 画面選択中の入力セクションを取得   
      const isRecycleSection = this.selectedDisposalInputSection === 'recycle'

      const params = {registration_type: this.selectedDisposalInputSection}

      if (isRecycleSection) {
        // 再資源化等情報

        //現在選択中のパターンID なければ、再資源化フロー先頭行のrecycle_disposer_disposal_method_id どちらもなければ null
        const recycleDisposalMethodId =
          this.manifest?.pattern?.id ||
          this.manifestDisposal?.manifest_recycle_disposal_reports?.[0]?.recycle_disposer_disposal_method_id ||
          null

        Object.assign(params, {
          disposal_standard_quantity_type: this.manifestDisposal.disposal_standard_quantity_type,
          disposal_quantity: this.manifestDisposal.disposal_quantity,
          recycle_disposer_disposal_method_id: recycleDisposalMethodId,
          manifest_recycle_disposal_reports: this.manifestDisposal.manifest_recycle_disposal_reports,
        })
      } else {
        // 処分終了報告
        Object.assign(params, {
          disposal_report_type: this.manifestDisposal.disposal_report_type,
          disposal_report_person: this.manifestDisposal.disposal_report_person,
          disposal_report_end_date: this.manifestDisposal.disposal_report_end_date,
          disposal_report_reporter: this.manifestDisposal.disposal_report_reporter,
          disposal_report_driver: this.manifestDisposal.disposal_report_driver,
          disposal_report_vehicle_number: this.manifestDisposal.disposal_report_vehicle_number,
          disposal_report_receipt_date: this.manifestDisposal.disposal_report_receipt_date,
          disposal_report_amount: this.manifestDisposal.disposal_report_amount,
          disposal_report_amount_unit_id: this.manifestDisposal.disposal_report_amount_unit_id,
          disposal_report_remarks: this.manifestDisposal.disposal_report_remarks,
        })
      }

      this.updateManagementDisposal({ id: this.targetManifestId, params: params }).then(() => {
        this.$emit('registerEvent')
      })
    },
    /**
     * 運搬報告タブ 区間チェンジイベント コールバック
     * @param id
     */
    sectionChangeEvent (id) {
      this.setManifestTransport(id)
    },
    /**
     * 処分報告入力セクション 変更イベント
     * @param section
     */
    inputSectionChangeEvent (section) {
      this.selectedDisposalInputSection = section
    },
    /**
     * 運搬報告のデータ取得・展開
     * @param manifest_transport_id
     */
    setManifestTransport (manifest_transport_id) {
      /**
       * @property content.transport_indication_setting { Hash } 運搬報告の制御
       */
      this.currentDraftTransportId = manifest_transport_id
      this.fetchManifestTransport({manifest_id: this.targetManifestId, id: manifest_transport_id}).then((content) => {
        this.manifestDraftTransport = content.manifest_draft_transport
        this.indication_setting.transport = content.transport_indication_setting
        this.proxyRequest = content.proxy_request
      })
    },
  }
}
</script>
